__turbopack_context__.v({
  "actionButton": "_9ghq4q_actionButton",
  "bookingLoading": "_9ghq4q_bookingLoading",
  "contactFormAnchor": "_9ghq4q_contactFormAnchor",
  "inquiryPanel": "_9ghq4q_inquiryPanel",
  "modeSwitch": "_9ghq4q_modeSwitch",
  "modeTabs": "_9ghq4q_modeTabs",
  "newBadge": "_9ghq4q_newBadge" + " " + __turbopack_context__.i(262643)["brandchip"],
  "panelBody": "_9ghq4q_panelBody",
  "unconfigured": "_9ghq4q_unconfigured",
  "unconfiguredActions": "_9ghq4q_unconfiguredActions",
  "unconfiguredText": "_9ghq4q_unconfiguredText",
});
